// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"b02fdfbc","618":"f323b0a5","758":"e005c31b"}[chunkId] + ".chunk.js";
};